import { gql } from '@apollo/client';

export const EVENT_SURVEY_OPENED = gql`
    mutation surveyOpenedMutation($command: UpdateEventParticipantCommandInput!) {
        surveyOpened(command: $command) {
            surveyOpened
            certificateIssued
        }
    }
`;
